
  var storagePrefix = 'bi_secret_bogo_';
  var duration = 48 * 60 * 60 * 1000;
  var refreshTimer = null;

  function normalizeCampaign(value) {
  return (value || '')
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\+/g, ' ')
    .replace(/\s+/g, ' ');
}

  var params = new URLSearchParams(window.location.search);
  var utmCampaign = normalizeCampaign(params.get('utm_campaign'));

  if (utmCampaign) {
    localStorage.setItem(storagePrefix + utmCampaign, String(Date.now() + duration));
  }


  function updateGridNewBadges(root) {
  root = root || document;

  root.querySelectorAll('.product-item').forEach(function (card) {
    var newBadge = null;

    card.querySelectorAll('.badge-box').forEach(function (badge) {
      if (badge.textContent.trim().toUpperCase() === 'NEW') {
        newBadge = badge;
      }
    });

    if (!newBadge) return;

    var hasSaleBadge = !!card.querySelector('.badge-sale, .badge-sale-grid');
    if (hasSaleBadge) {
      return;
    }

    var hasVisibleBogo = false;

    card.querySelectorAll('.bogo-badge').forEach(function (bogo) {
      if (window.getComputedStyle(bogo).display !== 'none') {
        hasVisibleBogo = true;
      }
    });

    if (hasVisibleBogo) {
      newBadge.classList.add('badge--bottom-left');
    } else {
      newBadge.classList.remove('badge--bottom-left');
    }
  });
}

  function hasActiveCampaignContains(campaignNeedle) {
    campaignNeedle = normalizeCampaign(campaignNeedle);
    if (!campaignNeedle) return false;

    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      if (!key || key.indexOf(storagePrefix) !== 0) continue;

      var storedCampaign = normalizeCampaign(key.replace(storagePrefix, ''));
      var expiresAt = parseInt(localStorage.getItem(key) || '0', 10);

      if (expiresAt <= Date.now()) {
        localStorage.removeItem(key);
        i--;
        continue;
      }

      if (storedCampaign.indexOf(campaignNeedle) !== -1) {
        return true;
      }
    }

    return false;
  }
function matchesSecretCampaign(campaign1, campaign2) {
  campaign1 = normalizeCampaign(campaign1);
  campaign2 = normalizeCampaign(campaign2);

  return (
    (campaign1 && hasActiveCampaignContains(campaign1)) ||
    (campaign2 && hasActiveCampaignContains(campaign2))
  );
}
 function isAnySecretBogoActive() {
  for (var i = 0; i < localStorage.length; i++) {
    var key = localStorage.key(i);
    if (!key || key.indexOf(storagePrefix) !== 0) continue;

    var expiresAt = parseInt(localStorage.getItem(key) || '0', 10);
    if (expiresAt > Date.now()) {
      return true;
    }
  }

  return false;
}

  function toggleSecretBogoMenuState() {
    if (isAnySecretBogoActive()) {
      document.body.classList.add('secret-bogo-active');
    } else {
      document.body.classList.remove('secret-bogo-active');
    }
  }

  function refreshSecretBogo(root) {
    root = root || document;

   root.querySelectorAll('.js-secret-bogo').forEach(function (el) {
  var isSecret = el.getAttribute('data-secret-bogo') === 'true';
  var mode = el.getAttribute('data-secret-mode') || 'only';
  var campaign1 = el.getAttribute('data-secret-campaign');
  var campaign2 = el.getAttribute('data-secret-campaign-2');
  var matched = matchesSecretCampaign(campaign1, campaign2);

  if (!isSecret) {
    el.style.display = '';
    return;
  }

  if (mode === 'only') {
    el.style.display = matched ? '' : 'none';
  } else if (mode === 'hide') {
    el.style.display = matched ? 'none' : '';
  }
});

   document.querySelectorAll('.bogo-cart-wrapper.js-secret-bogo').forEach(function (wrapper) {
  var isSecret = wrapper.getAttribute('data-secret-bogo') === 'true';
  var campaign1 = wrapper.getAttribute('data-secret-campaign');
  var campaign2 = wrapper.getAttribute('data-secret-campaign-2');
  var matched = matchesSecretCampaign(campaign1, campaign2);

  if (!isSecret) {
    wrapper.style.display = '';
  } else if (matched) {
    wrapper.style.display = '';
  } else {
    wrapper.style.display = 'none';
  }
});

toggleSecretBogoMenuState();
updateGridNewBadges(root);
  }

  function queueRefresh(root) {
    if (refreshTimer) return;

    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      refreshSecretBogo(root || document);
    }, 120);
  }

  refreshSecretBogo(document);

  var observer = new MutationObserver(function (mutations) {
    var shouldRefresh = false;

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (!node || node.nodeType !== 1) continue;

        if (
          (node.matches && (
            node.matches('.js-secret-bogo') ||
            node.matches('.product-item') ||
            node.matches('.grid-item') ||
            node.matches('.product__slide') ||
            node.matches('[data-related-section]') ||
            node.matches('.recent__content')
          )) ||
          (node.querySelector && (
            node.querySelector('.js-secret-bogo') ||
            node.querySelector('.product-item') ||
            node.querySelector('.product__slide')
          ))
        ) {
          shouldRefresh = true;
          break;
        }
      }

      if (shouldRefresh) break;
    }

    if (shouldRefresh) {
      queueRefresh(document);
    }
  });

    var observerTargets = [];

  document.querySelectorAll(
    '.collection__products, .product-grid, .collection-grid, .grid, [data-related-section], .recent__content, .drawer__inner, #cart-drawer, cart-drawer'
  ).forEach(function (el) {
    observerTargets.push(el);
  });

  if (!observerTargets.length) {
    var fallbackMain = document.querySelector('.main-content');
    if (fallbackMain) observerTargets.push(fallbackMain);
  }

  observerTargets.forEach(function (target) {
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  });